import React, { useEffect } from 'react';
import { HStack, Input } from 'native-base';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { useShopStyles } from '~/shared/styles';

export type SBRangeSliderProps = {
  minValue: number;
  maxValue: number;
  lowerBound?: number;
  upperBound?: number;
  onChangeMinValue: (value: number) => void;
  onChangeMaxValue: (value: number) => void;
  type: 'currency' | 'percentage'
};

export const SBRangeSlider = ({
    minValue,
    maxValue,
    lowerBound = 0,
    upperBound = 999,
    onChangeMinValue,
    onChangeMaxValue,
    type = 'currency'
}: SBRangeSliderProps) => {

    const { icon, button_background, input_background } = useShopStyles();

    const onChangeMinValueText = (value) => {

        const intValue = parseInt(value.toString().replaceAll('$', '').slice(0, 3));
        onChangeMinValue(intValue || 0);
    };

    const onChangeMaxValueText = (value) => {

        const intValue = parseInt(value.toString().replaceAll('$', '').slice(0, 3));
        onChangeMaxValue(intValue || 0);
    };

    const onBlurMaxValue = () => {

        if (maxValue < minValue) {
            onChangeMaxValue(minValue);
        }

        if (maxValue > upperBound) {
            onChangeMaxValue(upperBound);
        }
    };

    const onBlurMinValue = () => {

        if (minValue > maxValue) {
            onChangeMinValue(maxValue);
        }

        if (minValue < lowerBound) {
            onChangeMinValue(lowerBound);
        }
    };

    useEffect(() => {
      const style = document.createElement('style');
      style.innerHTML = `
        .range-slider__range {
          background-color: ${icon} !important;
        }
        .range-slider__thumb {
          background-color: ${icon} !important;
        }
      `;
      document.head.appendChild(style);
      return () => {
        document.head.removeChild(style);
      };
    }, []);

    return <HStack alignItems={'center'} justifyContent={'center'} space={2}>
        <Input
            onChangeText={onChangeMinValueText}
            onBlur={onBlurMinValue}
            value={type === 'currency' ? `$${minValue}` : `${minValue}%`}
            color={button_background}
            borderColor={button_background}
            bg={input_background}
            textAlign={'center'}
            flex={1}
            minW={'40px'}
            px={0}
        />
        <RangeSlider
            onInput={(value: number[]) => {

                onChangeMinValue(value[0]); onChangeMaxValue(value[1]);
            }}
            min={lowerBound}
            max={upperBound}
            value={[minValue, maxValue]}
            markerColor={icon}
            flex={4}
        />
        <Input
            onChangeText={onChangeMaxValueText}
            onBlur={onBlurMaxValue}
            value={type === 'currency' ? `$${maxValue}` : `${maxValue}%`}
            color={button_background}
            bg={input_background}
            borderColor={button_background}
            textAlign={'center'}
            flex={1}
            minW={'40px'}
            px={0}
        />
    </HStack>;
};
